import React from "react";
import { Navigate, Outlet } from "react-router-dom";

const ProtectedLayout = () => {
  const adminId = localStorage.getItem("admin_id");

  if (!adminId) {
    return <Navigate to="/" replace />;
  }

  return <Outlet />; 
};

export default ProtectedLayout;
